import {
  MENU_CREDENTIALS,
  ROUTE_CREDENTIALS
} from '@/config/constants/credentials-mapping'
import { MenuItemKeys } from '@/config/constants/menu-item-keys'

/**
 * Get required credentials for a menu item
 */
export const getMenuItemCredentials = (menuId: MenuItemKeys): string[] => {
  return MENU_CREDENTIALS[menuId] || []
}

/**
 * Get required credentials for a route
 */
export const getRouteCredentials = (route: string): string[] => {
  return ROUTE_CREDENTIALS[route] || []
}

/**
 * Check if user has any of the credentials that give access to a menu item
 */
export const hasMenuItemAccess = (
  menuId: MenuItemKeys,
  userCredentials: string[]
): boolean => {
  const requiredCredentials = getMenuItemCredentials(menuId)
  if (!requiredCredentials.length) return true
  return requiredCredentials.some((cred) => userCredentials.includes(cred))
}

/**
 * Check if user has any of the credentials that give access to a route
 */
export const hasRouteAccess = (
  route: string,
  userCredentials: string[]
): boolean => {
  const requiredCredentials = getRouteCredentials(route)
  if (!requiredCredentials.length) return true
  return requiredCredentials.some((cred) => userCredentials.includes(cred))
}
